<template>
  <div>
    <v-card @click="dialog = true" class="item" tile flat depressed>
      <div class="position-relative">
        <img
          class="d-block item-img"
          :src="`//img.youtube.com/vi/${getYoutubeCode(video)}/hqdefault.jpg`"
          :alt="title"
          width="100%"
        />

        <div class="d-flex align-center justify-center play-icon">
          <v-icon color="white" size="50"> fa-play </v-icon>
        </div>
      </div>

      <div class="primary--text text-body-1 font-weight-bold py-3 item-title">
        {{ title }}
      </div>
    </v-card>

    <v-dialog content-class="video-dialog" v-model="dialog" max-width="1200px">
      <v-btn
        @click="dialog = false"
        class="close-dialog"
        color="white"
        small
        fab
      >
        <v-icon color="warning darken-4" size="20"> fa-times </v-icon>
      </v-btn>

      <div class="position-relative video">
        <div class="d-flex align-center justify-center loading-video">
          <LoadingWidget color="white" />
        </div>

        <youtube
          class="position-relative"
          :video-id="videoId"
          ref="youtube"
          :player-vars="{ autoplay: 1 }"
        />
      </div>
    </v-dialog>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import { getYoutubeCode } from "../../utils/getYoutubeCode";

export default {
  data: () => ({
    dialog: false,
    videoId: "",
  }),
  props: {
    video: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    getYoutubeCode,
  },
  watch: {
    dialog() {
      if (!this.dialog) this.videoId = "";
      else this.videoId = getYoutubeCode(this.video);
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 16 / 9;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .play-icon {
    background-color: transparent;
    bottom: 0;
    left: 0;
    opacity: 0.7;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.1s linear;
  }

  &:hover {
    .play-icon::v-deep {
      opacity: 1;

      .v-icon {
        color: rgba(204, 0, 0, 0.9) !important;
      }
    }
  }
}

.loading-video {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>

<style lang="scss">
.video-dialog {
  overflow-y: inherit;
  position: relative;

  .close-dialog {
    position: absolute;
    right: 0;
    top: -50px;
  }
}
</style>
